export default "__VITE_ASSET__CyO7us5W__"